import type { ValueOf } from 'cpool-utils';

export const NUMBER_SWITCH_TARGET_KINDS = {
    OPEN_CHAT: 'openChat',
    START_APPLICANT_CHAT: 'startApplicantChat',
    START_PARTNER_CHAT: 'startPartnerChat',
} as const;

export type NumberSwitchTargetKind = ValueOf<typeof NUMBER_SWITCH_TARGET_KINDS>;
